import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const DEFAULT_IMAGE = '/assets/images/example-post.jpg';
const MAX_SLIDES = 10;

const CustomSlider = ({ slides = [], settings: customSettings = {} }) => {
  const defaultSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true
  };

  const settings = { ...defaultSettings, ...customSettings };
  const limitedSlides = slides.slice(0, MAX_SLIDES);

  const handleImageError = (e) => {
    console.log('Image failed to load, using default image');
    e.target.src = DEFAULT_IMAGE;
  };

  return (
    <div className="custom-slider">
      <Slider {...settings}>
        {limitedSlides.map((slide) => (
          <div key={slide.id} className="slider-item">
            <img 
              src={slide.image || DEFAULT_IMAGE} 
              alt={slide.title}
              onError={handleImageError}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default CustomSlider;
